// extracted by mini-css-extract-plugin
export var grid = "NewsSection-module--grid--39e46";
export var image = "NewsSection-module--image--202b1";
export var link = "NewsSection-module--link--7b956";
export var paper = "NewsSection-module--paper--5787d";
export var rectangle = "NewsSection-module--rectangle--47ded";
export var root = "NewsSection-module--root--488fd";